import Typography from "@portal/components/atoms/v2/typography";
import Icon from "@portal/components/atoms/icons";
import { TextResources } from "@portal/assets/text/TextResources";
import { IAddCashAccountButton } from "./types";
import { FC } from "react";
import useNewCashAccount from "@portal/hooks/useNewCashAccount";

const AddCashAccountButton: FC<IAddCashAccountButton> = ({ handleClick }) => {
  const { clearShowCompleteMessage } = useNewCashAccount();

  const handleAddCashAccount = () => {
    clearShowCompleteMessage();
    handleClick();
  };
  return (
    <button className="text-blue flex flex-row items-center space-x-1" onClick={handleAddCashAccount}>
      <Icon name="plusCircleIcon" size="xsmall" />
      <Typography variant="Description">{TextResources.ADD_CASH_ACCOUNT_BUTTON_TEXT}</Typography>
    </button>
  );
};

export default AddCashAccountButton;
